import type { IColors } from "@swiggy-private/dls-web-common/dist/components/types.internal";

export enum IPaymentType {
    SWIGGY = "SWIGGY",
    RAZORPAY = "RAZORPAY",
}

export interface IPaymentOffer {
    icon: string;
    text: string;
    colorToken: keyof IColors;
}

export interface IPaymentCTA {
    link: string;
    text: string;
    type: "PRIMARY" | "SECONDARY";
}

export interface IPaymentCard {
    type: IPaymentType;
    icon: string;
    iconName?: string;
    iconColor?: keyof IColors;
    title: string;
    strikeThroughAmount?: string;
    savingsAmount?: string;
    finalAmount?: string;
    offers: IPaymentOffer[];
    cta: IPaymentCTA;
    ctaMessage: string;
}

export interface IPaymentOptionsData {
    cards?: IPaymentCard[];
    separatorImage?: string;
    shownOfferLimit?: number;
}

export interface IPaymentOption extends IPaymentCard {
    id: string;
    shownOfferLimit?: number;
}

export interface IPaymentOptionsProps extends IPaymentOptionsData {
    onBackClick: () => void;
    onPaymentCTAClick: (card: IPaymentCard) => void;
    onPaymentCardClickAnalytics?: (card: IPaymentCard, index: number, objectName: string) => void;
}

export interface ITitleSegments {
    beforeStrike: string;
    middle: string;
    afterFinalAmount: string;
}
